module.exports = __webpack_public_path__ + "d76a77dc0a9ff567edb92fb20425c0ff.png";